import _sfc_main from './UiPagination.vue2.js';
import normalizeComponent from '../../_virtual/_plugin-vue2_normalizer.js';

var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("nav", { staticClass: "fds-widget fds-ui-pagination", attrs: { "aria-label": _setup.translate("uiPagination.caption") } }, [_vm._t("root", function() {
    return [_c("ul", { staticClass: "fds-ui-pagination__container" }, [_c("li", { key: "first", staticClass: "fds-ui-pagination__button-wrapper" }, [_vm._t("button(first)", function() {
      return [_c("button", { staticClass: "fds-ui-pagination__button", attrs: { "type": "button", "disabled": _setup.isPaginationBackDisabled, "aria-label": _setup.translate("uiPagination.first") }, on: { "click": function($event) {
        $event.preventDefault();
        return _setup.onClickPaginationFirst();
      }, "keyup": function($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter"))
          return null;
        return _setup.onClickPaginationFirst();
      } } }, [_c("span", { staticClass: "fds-ui-icon fds-ui-icon--first" })])];
    }, null, { localizationSupport: _setup.localizationSupport, onClickPaginationFirst: _setup.onClickPaginationFirst, isPaginationBackDisabled: _setup.isPaginationBackDisabled, label: "uiPagination.first" })], 2), _c("li", { key: "previous", staticClass: "fds-ui-pagination__button-wrapper" }, [_vm._t("button(previous)", function() {
      return [_c("button", { staticClass: "fds-ui-pagination__button", attrs: { "type": "button", "disabled": _setup.isPaginationBackDisabled, "aria-label": _setup.translate("uiPagination.previous") }, on: { "click": function($event) {
        $event.preventDefault();
        return _setup.onClickPaginationBack();
      }, "keyup": function($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter"))
          return null;
        return _setup.onClickPaginationBack();
      } } }, [_c("span", { staticClass: "fds-ui-icon fds-ui-icon--prev" })])];
    }, null, { localizationSupport: _setup.localizationSupport, onClickPaginationBack: _setup.onClickPaginationBack, isPaginationBackDisabled: _setup.isPaginationBackDisabled, label: "uiPagination.previous" })], 2), _vm._t("pages", function() {
      return [_vm._l(_setup.pages, function(page, index) {
        return [_c("li", { key: page === "..." ? `truncate-${index}` : `button-${page}`, staticClass: "fds-ui-pagination__button-wrapper" }, [page !== "..." ? [_vm._t("pages:button(page)", function() {
          return [_c("button", { ref: (
            // @ts-ignore cannot properly detect type of element
            (element) => _setup.populateButtonRef(page, element)
          ), refInFor: true, staticClass: "fds-ui-pagination__button", class: { "fds-ui-pagination__button--active": _setup.isActive(page) }, attrs: { "type": "button", "aria-current": _setup.isActive(page), "aria-label": _setup.translate("uiPagination.page", { page: _setup.numberFormat(+page, { type: "integer" }) }) }, on: { "click": function($event) {
            return _setup.onClickPaginationButton(page);
          }, "keyup": function($event) {
            if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter"))
              return null;
            return _setup.onClickPaginationButton(page);
          } } }, [_c("span", [_vm._v(_vm._s(_setup.numberFormat(+page, { type: "integer" })))])])];
        }, null, { localizationSupport: _setup.localizationSupport, getRefKey: _setup.getRefKey, pages: _setup.pages, page, isActive: _setup.isActive, onClickPaginationButton: _setup.onClickPaginationButton, label: "uiPagination.page" })] : [_vm._t("pages:truncation", function() {
          return [_c("div", { staticClass: "fds-ui-pagination__truncation" }, [_vm._v(_vm._s(page))])];
        })]], 2)];
      })];
    }, null, { localizationSupport: _setup.localizationSupport, pages: _setup.pages, getRefKey: _setup.getRefKey, isActive: _setup.isActive, onClickPaginationButton: _setup.onClickPaginationButton }), _c("li", { key: "next", staticClass: "fds-ui-pagination__button-wrapper" }, [_vm._t("button(next)", function() {
      return [_c("button", { staticClass: "fds-ui-pagination__button", attrs: { "type": "button", "disabled": _setup.isPaginationNextDisabled, "aria-label": _setup.translate("uiPagination.next") }, on: { "click": function($event) {
        $event.preventDefault();
        return _setup.onClickPaginationForward();
      }, "keyup": function($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter"))
          return null;
        return _setup.onClickPaginationForward();
      } } }, [_c("span", { staticClass: "fds-ui-icon fds-ui-icon--next" })])];
    }, null, { localizationSupport: _setup.localizationSupport, pages: _setup.pages, isPaginationNextDisabled: _setup.isPaginationNextDisabled, onClickPaginationForward: _setup.onClickPaginationForward, label: "uiPagination.next" })], 2), _c("li", { key: "last", staticClass: "fds-ui-pagination__button-wrapper" }, [_vm._t("button(last)", function() {
      return [_c("button", { staticClass: "fds-ui-pagination__button", attrs: { "type": "button", "disabled": _setup.isPaginationNextDisabled, "aria-label": _setup.translate("uiPagination.last") }, on: { "click": function($event) {
        $event.preventDefault();
        return _setup.onClickPaginationLast();
      }, "keyup": function($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter"))
          return null;
        return _setup.onClickPaginationLast();
      } } }, [_c("span", { staticClass: "fds-ui-icon fds-ui-icon--last" })])];
    }, null, { localizationSupport: _setup.localizationSupport, pages: _setup.pages, isPaginationNextDisabled: _setup.isPaginationNextDisabled, onClickPaginationLast: _setup.onClickPaginationLast, label: "uiPagination.last" })], 2)], 2)];
  }, null, {
    localizationSupport: _setup.localizationSupport,
    pages: _setup.pages,
    onClickPagination: _setup.onClickPagination,
    onClickPaginationFirst: _setup.onClickPaginationFirst,
    isPaginationBackDisabled: _setup.isPaginationBackDisabled,
    onClickPaginationBack: _setup.onClickPaginationBack,
    onClickPaginationButton: _setup.onClickPaginationButton,
    onClickPaginationForward: _setup.onClickPaginationForward,
    onClickPaginationLast: _setup.onClickPaginationLast
  })], 2);
};
var _sfc_staticRenderFns = [];
_sfc_render._withStripped = true;
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
__component__.options.__file = "/home/ubuntu/actions-runner/_work/library/library/packages/library/src/components/ui-pagination/UiPagination.vue";
var UiPagination = __component__.exports;

export { UiPagination as default };
